import axios, { AxiosInstance } from 'axios'

import { getConfig } from '@/configs'

interface AxiosInstances {
  offerwallApi: AxiosInstance
  offerwallListApi: AxiosInstance
  adisonOfwGlobalApi: AxiosInstance
}

async function createAxiosInstances(): Promise<AxiosInstances> {
  const config = await getConfig()

  const offerwallApi = axios.create({
    baseURL: config.adisonOfw.baseUrl,
    timeout: 10 * 1000
  })

  const offerwallListApi = axios.create({
    baseURL: config.adisonOfwList.baseUrl,
    timeout: 10 * 1000
  })

  const adisonOfwGlobalApi = axios.create({
    baseURL: config.adisonOfwGlobal.baseUrl,
    timeout: 10 * 1000
  })

  return { offerwallApi, offerwallListApi, adisonOfwGlobalApi }
}

// 싱글톤 인스턴스 저장
let axiosInstances: AxiosInstances | null = null

// axios 인스턴스 초기화
export async function initializeAxios(): Promise<AxiosInstances> {
  if (!axiosInstances) {
    axiosInstances = await createAxiosInstances()
  }

  return axiosInstances
}

// axios 인스턴스 가져오기
export async function getAxiosInstances(): Promise<AxiosInstances> {
  if (!axiosInstances) {
    return initializeAxios()
  }

  return axiosInstances
}

export default getAxiosInstances
